<template>
    <div class="card">
        <div class="card-body">
            <b-form @submit.prevent="checkForm">
              <div class="row space-beetwen">
                <h5 class="card-title mb-4">Información del usuario</h5>
                <div>
                  <b-button type="submit" variant="danger">
                   <strong v-if="!busyContact"> Actualizar</strong>
                   <b-spinner v-else small class="align-middle"></b-spinner>
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <b-form-group label="*Nombre" label-for="formrow-name-input">
                    <b-form-input
                      id="formrow-name-input"
                      v-model="profile.nombre"
                      :class="[tieneError('nombre') ? 'is-invalid' : '']"
                    />
                    <span v-if="tieneError('nombre')" class="msjError">Error en el nombre ingresado</span>
                  </b-form-group>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <b-form-group
                      label="*Apellido"
                      label-for="formrow-lastname-input"
                    >
                      <b-form-input
                        id="formrow-lastname-input"
                        v-model="profile.apellido"
                        :class="[tieneError('apellido') ? 'is-invalid' : '']"
                      />
                      <span v-if="errors.includes('apellido')" class="msjError">Error en el apellido ingresado</span>
                    </b-form-group>
                  </div>
                </div>

                <div class="col-md-6">
                  <b-form-group label="*Email" label-for="formrow-email">
                    <b-form-input
                      id="formrow-email"
                      v-model="profile.email[0]"
                      :class="[tieneError('email') ? 'is-invalid' : '']"
                    />
                    <span v-if="errors.includes('email')" class="msjError">Error en el email ingresado</span>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Direccion" label-for="formrow-address">
                    <b-form-input
                      id="formrow-address"
                      v-model="profile.direccion"
                      :class="[tieneError('direccion') ? 'is-invalid' : '']"
                    />
                    <span v-if="errors.includes('direccion')" class="msjError">Error en la dirección ingresada</span>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group label="Celular" label-for="formrow-phone">
                    <b-form-input
                      id="formrow-phone"
                      type="number"
                      v-model="fono"
                      placeholder="+56 9 XXXX-XXXX"
                      :class="[tieneError('celular') || tieneError('celularFormat') ? 'is-invalid' : '']"
                    />
                    <span v-if="errors.includes('celular')" class="msjError">Error en el celular ingresado</span>
                    <span v-if="errors.includes('celularFormat')" class="msjError">El formato ingresado es incorrecto</span>
                  </b-form-group>
                </div>
              </div>
            </b-form>
            <div class="row space-beetwen">
              <h5 class="card-title mb-4">Cambio de contraseña</h5>
              <div>                
                <b-button type="submit" variant="danger" @click="cambiarPassBA()">                  
                  <strong v-if="!busyPass">Actualizar Contraseña</strong>
                  <b-spinner v-else small class="align-middle"></b-spinner>
                </b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <b-form-group
                    label="*Contraseña actual"
                    label-for="formrow-actpass-input"
                  >
                    <b-form-input
                      id="formrow-actpass-input"
                      type="password"
                      v-model="profile.password"
                      :class="[tieneError('pass') ? 'is-invalid' : '']"
                    />
                    <span v-if="errors.includes('pass')" class="msjError">Error en la contraseña ingresada</span>
                  </b-form-group>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <b-form-group
                    label="*Nueva contraseña"
                    label-for="formrow-newpass-input"
                  >
                    <b-form-input
                      id="formrow-newpass-input"
                      type="password"
                      v-model="changePw1"
                      :class="[tieneError('chpass') ? 'is-invalid' : '' || tieneError('chpass1') ? 'is-invalid' : '']"
                    />
                    <span v-if="errors.includes('chpass')" class="msjError">La contraseña nueva y la confirmación no coinciden</span>
                    <span v-if="errors.includes('chpass1')" class="msjError">Error en la contraseña ingresada</span>
                  </b-form-group>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <b-form-group
                    label="*Confirmar contraseña"
                    label-for="formrow-newpass2-input"
                  >
                    <b-form-input
                      id="formrow-newpass2-input"
                      type="password"
                      v-model="changePw2"
                      :class="[tieneError('chpass') ? 'is-invalid' : '' || tieneError('chpass1') ? 'is-invalid' : '']"
                    />
                    <span v-if="errors.includes('chpass')" class="msjError">La contraseña nueva y la confirmación no coinciden</span>
                    <span v-if="errors.includes('chpass1')" class="msjError">Error en la contraseña ingresada</span>
                  </b-form-group>
                </div>
              </div>
            </div>
        </div>
        <modal
          :mensaje = this.mensajeModal
          :error = this.errorModal
          v-show="error"
          @close="error = false"
        />
    </div>
</template>

<script>
//import axios from "@/axios";
import { authMethods } from "@/state/helpers";
import { mapActions } from 'vuex'
import modal from '../modal-notificacion';
import { Auth } from 'portalba360';
import axios from "@/axios";

export default {
    data(){
        return{
            profile: undefined,
            changePw1: "",
            changePw2: "",
            mensajeModal: "",
            errorModal: false,
            error: false,
            errors: [],
            fono: "",
            busyPass: false,
            busyContact: false,
        }
    },
    components: { 
      modal
    },
    beforeMount() {
        this.profile = {
          ...this.$store.getters["auth/contacto"],
        };
        this.fono = this.profile.fono[0];
    },
    methods:{
        ...authMethods,
        ...mapActions(['auth']),
        tieneError(campo){
          return this.errors.includes(campo) ? true : false
        },
        checkForm(e){
          this.errors = [];

          //Campos requeridos
          if(this.profile.nombre == ""){
            this.errors.push('nombre');
          }
          if(this.profile.apellido == ""){
            this.errors.push('apellido');
          }
          if(this.profile.email == ""){
            this.errors.push('email');
          }
          if(this.profile.email == ""){
            this.errors.push('email');
          }else if (!this.validEmail(this.profile.email)) {
            this.errors.push('email');
          }

          //Valida celulares en Chile
          if(this.fono){
            if (!this.validCelular(this.fono)) {
              this.errors.push('celularFormat');
            }
          }
          
          if (!this.errors.length){
            e.preventDefault();
          } 
 
          if (this.errors.length > 0){
            e.preventDefault();
          }else{
            this.actualizarInfoBA(e);
          }
                   
        },
        validEmail (email) {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        },
        validCelular (cel) {
          var re = /^(\+56|0056|56)?[ -]{0,1}(9)[ -]{0,1}([0-9]){4}[ -]{0,1}([0-9]){4}$/;
          return re.test(cel);
        },
        async cambiarPassBA(){
          this.busyPass = true;
          this.errors = [];
          //Contraseña
          if(this.profile.password == "" || this.profile.password == undefined){
            this.errors.push('pass');
          }
          if(this.changePw1 == "" || this.changePw2 == ""){
            this.errors.push('chpass1');
          }
          if(this.changePw1 != this.changePw2){
            this.errors.push('chpass');
          }

          if (this.errors.length >= 1){
            this.busyPass = false;
            this.errorModal = true;
            this.mensajeModal = "Ocurrió un error al validar su contraseña.\nDatos no actualizados."
            this.error = true;
            return
          }

          let data = {
            pass1: this.profile.password,
            pass2: this.changePw1,
            pass3: this.changePw2
          }
          const userRecover = new Auth();
          try{
            await userRecover.updPass(data).then((resp)=>{
              if (resp.data.code == 200){
                this.busyPass = false;
                this.errorModal = false;
                this.mensajeModal = "Contraseña actualizada correctamente!"
                this.error = true;                
              }
            });              
          }catch(error){
            this.busyPass = false;
            this.errorModal = true;
            this.mensajeModal = "Ocurrió un error al validar su contraseña.\nDatos no actualizados."
            this.error = true;
            this.errors.push('pass');
          }
        },
        async actualizarInfoBA(e){
          this.busyContact = true;
          let user = new Auth();
          let userSave = user.getBy({ id: this.$store.getters["auth/contacto"].id }).then((resp)=>{
            userSave = resp.data[0];
            userSave.nombre = this.profile.nombre;
            userSave.apellido = this.profile.apellido;
            userSave.nombre = this.profile.nombre;            
            userSave.email = [this.profile.email[0]];
            userSave.direccion = this.profile.direccion;
            userSave.fono = [this.fono];
            try{
                user.upd(userSave).then((resp)=>{
                  if (resp.request.status == 200){
                    this.actualizarInfoMITTA(e);
                  }
                });              
            }catch(error){
              this.busyContact = false;
              this.errorModal = true;
              this.mensajeModal = "Ocurrió un error al actualizar sus datos."           
              this.error = true;
              e.preventDefault();
            }

          });
        },
        actualizarInfoMITTA(e){
          let data = {
            "rut": parseInt(this.profile.identificador),
            "dv": "6",
            "primerNombre": this.profile.nombre,
            "segundoNombre": "",
            "apPaterno": this.profile.apellido,
            "apMaterno": "",
            "telefono": "",
            "celular": this.fono ? this.fono : "",
            "direccion": this.profile.direccion,
            "email": this.profile.email[0],
            "fechaCumpleanio": "0001-01-01T00:00:00",
            "rutEmpresa": 0,
            "dvEmpresa": null,
            "sexo": 0
          }
          axios
              .put("/ActualizarContacto", data)
              .then(() => {
                this.busyContact = false;
                this.errorModal = false;
                this.mensajeModal = "Tus datos fueron actualizados correctamente!\n" + 
                "Para ver reflejados los cambios por favor inicia sesión nuevamente"
                this.error = true;
              })
              .catch(() => {
                this.busyContact = false;
                this.errorModal = true;
                this.mensajeModal = "Actualizamos tus datos en los servidores de BA360 pero ocurrió un error al actualizarlos en MITTA."
                this.error = true;
                e.preventDefault();
              });          
      },
  }
}
</script>

<style scoped>
.card{
    border-radius: 0 !important;
}
.msjError{
  font-size: 0.7rem;
  color: red;
}
</style>